import { render, staticRenderFns } from "./FormsTable.vue?vue&type=template&id=35244596&scoped=true"
import script from "./FormsTable.vue?vue&type=script&lang=js"
export * from "./FormsTable.vue?vue&type=script&lang=js"
import style0 from "./FormsTable.vue?vue&type=style&index=0&id=35244596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35244596",
  null
  
)

export default component.exports